import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * TL;DR / Quick Answer callout designed for AI Overviews.
 *
 * Google's AI Overview favors a clear, direct 2-3 sentence answer at the
 * top of a page. Render this right below the H1 with `label="Quick answer"`
 * or `label="TL;DR"` depending on context.
 */
const QuickAnswer = ({ label = 'Quick answer', children, className = '' }) => (
  <aside
    data-testid="quick-answer-box"
    className={`bg-white border-l-4 border-blue-500 rounded-2xl shadow-sm p-6 mb-10 ${className}`}
  >
    <div className="flex items-center gap-2 text-blue-600 text-xs font-semibold uppercase tracking-wider mb-2">
      <Sparkles className="w-4 h-4" />
      {label}
    </div>
    <p className="text-lg text-gray-800 leading-relaxed">{children}</p>
  </aside>
);

export default QuickAnswer;
